import React from 'react'

import dbCodes from '../../server/dbCodes.js'
import {getColliTypeName} from '../../utils/getColliTypeName.js'
import {Button, Colors, Card, H4, S1, P, Modal, Icon} from '../../src/components/UI/index.js'
import Select from './UI/Select.js'
import {formSpacing} from '../../src/components/UI/forms/index.js'

class PickupPopup extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            isOpen: false,
            colli: [],
            reseller: null
        }

        this.state = structuredClone(this.initialState)
    }

    open(colli, reseller) {
        colli = structuredClone(colli)

        colli.map((collo) => {
            if (collo.status !== 'collected') {
                collo.status = 'notcollected'
                collo.reason = 'notready'
            }
        })

        this.setState({isOpen: true, colli, reseller})

        return new Promise((resolve, reject) => {
            this.resolve = resolve
            this.reject = reject
        })
    }

    close() {
        this.setState(this.initialState)
    }

    updateColloStatus(colloIndex, event) {
        const colli = [...this.state.colli]

        colli[colloIndex].reason = event.target.value

        this.setState({colli})
    }

    submit() {
        const {colli} = this.state

        this.resolve(colli)
        this.close()
    }

    render() {
        const {isOpen, colli, reseller} = this.state

        return (
            <Modal show={isOpen} style={{width: 600, maxWidth: '90%'}} onClose={this.close.bind(this)}>
                <div style={{display: 'flex', marginBottom: 24}}>
                    <Icon style={{marginRight: 6, color: Colors.errorBright, fontSize: 22}} icon='mdi mdi-alert' />
                    <H4>Ophalen incompleet</H4>
                </div>

                <P style={{marginBottom: 12}}>Onderstaande colli zijn niet opgehaald. Geef hieronder een reden op, of druk op Terug om ze alsnog te op te halen.</P>

                {colli.map((collo, colloIndex) => {
                    if (collo.status !== 'collected') {
                        return (
                            <Card key={`collo${collo.index}`} style={{background: Colors.grey20, padding: formSpacing.inset, marginBottom: 12}}>
                                <div style={{display: 'flex', alignItems: 'center', marginBottom: 12}}>
                                    <S1 style={{marginRight: 12}}>{collo.index + 1}</S1>

                                    <P style={{flex: 1, marginRight: 6}}>{`${collo.barcode || 'Geen barcode'}`}</P>
                                    <P style={{flex: 1, marginLeft: 6}}>{getColliTypeName(collo.type, reseller)}</P>
                                </div>

                                <Select
                                    closeButton
                                    label='Reden'
                                    value={collo.reason}
                                    options={[
                                        {value: 'notready', title: dbCodes.colloReasons['notready']},
                                        {value: 'invalid', title: dbCodes.colloReasons['invalid']}
                                    ]}
                                    onChange={this.updateColloStatus.bind(this, colloIndex)}
                                />
                            </Card>
                        )
                    }
                })}

                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', columnGap: formSpacing.columnGap, marginTop: 24}}>
                    <Button
                        variant='text'
                        onClick={this.close.bind(this)}
                        label='Terug'
                    />

                    <Button
                        variant='text'
                        onClick={this.submit.bind(this)}
                        label='Bevestigen'
                    />

                </div>
            </Modal>
        )
    }
}

export default PickupPopup
